/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripVertical, faRotate } from "@fortawesome/free-solid-svg-icons";
import MessagesIcon from "../../../assets/icons/messages.svg2";
import MyScroll from "../MyScroll";
import HelpButton from "../../HelpContent/HelpButton";
import { Link } from "react-router-dom";
import { useGetProcessStatsQuery } from "../../store/slices/settingsSlice";
import { AbsoluteLoadingIndicator } from "../FullScreenLoadingIndicator";

export default function MessagingWidget({ processGUID, projectUUID }) {
  const [period, setPeriod] = useState("today");
  const [stats, setStats] = useState({
    sms: 0,
    voice: 0,
    email: 0,
    totalDelivered: 0,
    totalReplied: 0,
    totalFailed: 0,
    totalDispatched: 0,
    totalFormAccessed: 0,
    totalFormSubmitted: 0,
  });

  const getDateParam = () => {
    if (period === "today") return "today";
    if (period === "week") return "week";
    if (period === "month") return "month";
    return "";
  };

  // Fetch process stats
  const {
    data: processStatsData,
    isLoading: statsLoading,
    isFetching: statsFetching,
    refetch,
  } = useGetProcessStatsQuery({
    started: getDateParam(),
    ...(projectUUID && { project: projectUUID }),
    ...(processGUID && { process: processGUID }),
  });
  const loading = statsLoading || statsFetching;

  useEffect(() => {
    if (processStatsData) {
      setStats(
        processStatsData.reduce(
          (p, c) => ({
            ...p,
            [c.Channel]: p[c.Channel] + c.Delivered + c.Dispatched + c.Failed,
            totalDelivered: p.totalDelivered + c.Delivered,
            totalReplied: p.totalReplied + c.Replies,
            totalFailed: p.totalFailed + c.Failed,
            totalDispatched: p.totalDispatched + c.Dispatched,
            totalFormAccessed: p.totalFormAccessed + c.FormAccessed,
            totalFormSubmitted: p.totalFormSubmitted + c.FormSubmitted,
          }),
          {
            sms: 0,
            voice: 0,
            email: 0,
            totalDelivered: 0,
            totalReplied: 0,
            totalFailed: 0,
            totalDispatched: 0,
            totalFormAccessed: 0,
            totalFormSubmitted: 0,
          }
        )
      );
    }
  }, [processStatsData]);

  const totalDispatched =
    stats.totalDispatched + stats.totalFailed + stats.totalDelivered;

  return (
    <div className="position-relative d-flex flex-column h-100">
      <AbsoluteLoadingIndicator loading={loading} />
      <div className="d-flex p-3 pb-1 align-items-center ">
        <MessagesIcon width={20} className="white opacity-50" />
        <Link
          className="btn p-0 text-white text-start"
          to="/reporting/realtime"
        >
          <h6 className="m-0 mx-2 small fw-bold ">COMPONENT MESSAGING DATA</h6>
        </Link>
        <button
          className="btn p-0 text-white ms-2"
          onClick={() => refetch()}
          disabled={loading}
          title="Refresh messaging data"
        >
          <FontAwesomeIcon
            icon={faRotate}
            className={`opacity-50 ${loading ? "spin" : ""}`}
          />
        </button>
        <HelpButton helpKey="widget-messaging-data" iconClassName="white" />
        <FontAwesomeIcon
          icon={faGripVertical}
          className="ms-4 opacity-50 widget-header"
        />
      </div>
      <hr className="m-1" />
      <div className="flex-grow-1 d-flex flex-column justify-content-between">
        <h6 className="opacity-50 text-center m-0 mt-2">% Per channel</h6>

        <div className="flex-grow-1 d-flex flex-column justify-content-center align-items-center">
          <MyScroll scrollEndOnItemAdd={false}>
            <div className="row flex-nowrap">
              {[
                {
                  label: "SMS",
                  value:
                    totalDispatched !== 0
                      ? (stats.sms / totalDispatched) * 100
                      : 0,
                },
                {
                  label: "Voice",
                  value:
                    totalDispatched !== 0
                      ? (stats.voice / totalDispatched) * 100
                      : 0,
                },
                {
                  label: "Email",
                  value:
                    totalDispatched !== 0
                      ? (stats.email / totalDispatched) * 100
                      : 0,
                },
                // {
                //   label: "Whatsapp",
                //   value: 0,
                // },
                // {
                //   label: "Messenger",
                //   value: 0,
                // },
                // {
                //   label: "RCS",
                //   value: 0,
                // },
              ].map((ch, i, channels) => (
                <div
                  key={ch.label}
                  className={`col-auto text-center p-4 ${
                    i > 0 && i < channels.length - 2
                      ? "border-end border-secondary border-opacity-50"
                      : ""
                  }`}
                >
                  <h5 className="fw-bold m-0 text-nowrap">
                    {Math.round(ch.value)}%
                  </h5>
                  <span className="small opacity-50 fw-bold text-nowrap">
                    {ch.label}
                  </span>
                </div>
              ))}
            </div>
          </MyScroll>
        </div>
        <div>
          {[
            { label: "Total Delivered", value: stats.totalDelivered },
            { label: "Total Failed", value: stats.totalFailed },
            { label: "Total Responses", value: stats.totalReplied },
            {
              label: "Total Dispatched",
              value:
                stats.totalDispatched +
                stats.totalFailed +
                stats.totalDelivered,
            },
            { label: "Form accessed", value: stats.totalFormAccessed },
            { label: "Form submitted", value: stats.totalFormSubmitted },
          ].map((r, i) => (
            <React.Fragment key={i}>
              <div className="d-flex justify-content-between px-3">
                <span className="opacity-50 fw-bold">{r.label}</span>
                <h5 className="fw-bold m-0">{r.value}</h5>
              </div>
              <hr className="m-1" />
            </React.Fragment>
          ))}
        </div>
        <div className="p-3 d-flex justify-content-center">
          <button
            type="button"
            className={`btn btn-light btn-sm px-2 py-0 rounded-pill text-purple fw-bold mx-1 text-nowrap ${
              period === "today" ? "" : "opacity-50"
            }`}
            onClick={() => setPeriod("today")}
          >
            TODAY
          </button>
          <button
            type="button"
            className={`btn btn-light btn-sm px-2 py-0 rounded-pill text-purple fw-bold mx-1 text-nowrap ${
              period === "week" ? "" : "opacity-50"
            }`}
            onClick={() => setPeriod("week")}
          >
            THIS WEEK
          </button>
          <button
            type="button"
            className={`btn btn-light btn-sm px-2 py-0 rounded-pill text-purple fw-bold mx-1 text-nowrap ${
              period === "month" ? "" : "opacity-50"
            }`}
            onClick={() => setPeriod("month")}
          >
            THIS MONTH
          </button>
        </div>
      </div>
    </div>
  );
}
